<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="special_more_container">
    <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
      <news-list class="special_news_list" :contentList="specialNewsList" :deviceId="deviceId"></news-list>
    </van-list>
  </van-pull-refresh>
</template>
<script>
import { mapState } from "vuex";
import { getRandomStr32 } from "@/utils";
import specialApi from "@/api/apis/special.js";
import commApi from "@/api/apis/common.js";
import NewsList from "./components/SpecialNewsList";
export default {
  name: "SpecialNewsList",
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      /* 设备Id */
      deviceId: null,
      params: {
        currentPage: 0,
        pageSize: 20,
        contentClassifyId: null,
      },
      specialDetail: null,
      specialNewsList: [], //专题新闻列表
      specialNewsTotal: 0, //专题新闻总数
      specialNewsPageCount: 0, //专题新闻分页数
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  components: {
    NewsList,
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        var shareImgurl = "";
        if (!!_this.specialDetail.smallPicUrl && _this.specialDetail.smallPicUrl.length > 0) {
          shareImgurl = _this.specialDetail.smallPicUrl;
        } else if (!!_this.specialDetail.bigPicUrl && _this.specialDetail.bigPicUrl.length > 0) {
          shareImgurl = _this.specialDetail.bigPicUrl;
        }
        var desc = _this.specialDetail.summaryStatus ? _this.specialDetail.summarySth : _this.specialDetail.classifyName;
        _this.$WeiXin.shareWeiXin(res, _this.specialDetail.specialTitle, desc, location.href, shareImgurl);
        this.$emit('initWeiXinTicket');
      }).catch((err) => {
      })
    },
    /* 根据专题内容分类Id获取专题内容列表 */
    getSpecialContentsByClassifyId() {
      var _this = this;

      specialApi
        .getSpecialContentsByClassifyId(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.currentPage == 0) {
              document.title = res.data.specialTitle;
              _this.specialDetail = res.data;
              // 中宣部埋点：稿件详情页浏览（分页仅首页上报，并加 once 守卫防重复）
              _this.$track.trackPageViewOnce(
                _this.$track.EVENT_CODE.ARTICLE_DETAIL_PG,
                _this.$track.mapArticleProps(_this.specialDetail, {
                  pageName: "专题更多列表页",
                  pageId: "special_more",
                  extra: {
                    article_type: "专题",
                    article_name: res.data.specialTitle || "",
                    special_topic_name: res.data.specialTitle || "",
                  },
                })
              );
              _this.wechatShare(); // 微信二次分享
              _this.specialNewsList = res.data.list;
            } else {
              _this.specialNewsList = _this.specialNewsList.concat(
                res.data.list
              );
            }
            _this.specialNewsTotal = res.data.total;
            _this.specialNewsPageCount = Math.ceil(
              res.data.total / _this.params.pageSize
            );
            if (_this.params.currentPage >= _this.specialNewsPageCount - 1) {
              _this.finished = true;
            }
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.currentPage = 0;
      // this.specialNewsList = [];
      this.specialNewsTotal = 0;
      this.specialNewsPageCount = 0;
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      this.getSpecialContentsByClassifyId(); //根据专题内容分类Id获取专题内容列表
    },
    /* 上拉加载 */
    onLoadMore() {
      this.params.currentPage++;
      if (this.params.currentPage < this.specialNewsPageCount) {
        this.loading = true;
        this.getSpecialContentsByClassifyId(); //根据专题内容分类Id获取专题内容列表
      }
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "specialId")) {
      this.params.contentClassifyId = Number(query.specialId);
      if (!this.userInfo) {
        if (!!query.deviceId) {
          this.deviceId = query.deviceId;
        } else {
          this.deviceId = getRandomStr32();
        }
      }
      this.getSpecialContentsByClassifyId(); //根据专题内容分类Id获取专题内容列表
    }
  },
};
</script>
<style scoped lang="scss">
.special_more_container {
  width: 100%;
  height: 100%;
  padding: 0px 15px;
  overflow-x: hidden;
  overflow-y: auto;
  .special_more_list {
    .news_item {
      padding: 15px 0;
      border-bottom: 0.5px solid #ececec;
      .news_title {
        max-height: 45px;
        line-height: 22.5px;
        padding: 0;
        margin-bottom: 8px;
        overflow: hidden;
        color: #1a1a1a;
        font-size: 18px;
        font-weight: normal;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .news_info {
        overflow: hidden;
        color: #a1a1a1;
        font-size: 12px;
        white-space: nowrap;
        span {
          margin-right: 10px;
        }
      }
      &.news_item_small {
        display: flex;
        .thumbnail {
          width: 120px;
          height: 90px;
          line-height: 90px;
          margin-right: 12px;
          overflow: hidden;
          background-image: url(~@/assets/images/default_pic_16_9.png);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          img {
            object-fit: cover;
            min-width: 100%;
            min-height: 100%;
          }
        }
        .news_text {
          position: relative;
          width: 100%;
          padding: 0 0 16px 0;
          overflow: hidden;
          flex: 1;
          .news_title {
            max-height: 67.5px;
            -webkit-line-clamp: 3;
          }
          .news_info {
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
  }
}
</style>